import { render, staticRenderFns } from "./ParticaMetadata.vue?vue&type=template&id=554c8564&scoped=true&"
import script from "./ParticaMetadata.vue?vue&type=script&lang=ts&"
export * from "./ParticaMetadata.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaMetadata.vue?vue&type=style&index=0&id=554c8564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554c8564",
  null
  
)

export default component.exports